import { IGetRevisionHistory } from "@publishing-engine/submission-service/src/endpoints/api.response-types";
import { useState } from "react";
import AdjudicationDetailsModal from "./ReadOnly/AdjudicationDetailsModal";
import { Box, Flex, Text, Tooltip } from "@chakra-ui/react";
import { Badge, ButtonIcon, ButtonText, Table } from "@morressier/alembic";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/pro-regular-svg-icons";
import { recommendationBadges, reviewStatusBadges } from "src/components/Review/Badges";

const AdjudicationRoundHistory = ({ revision, configs, roundIndex }: { revision: IGetRevisionHistory; configs: any ; roundIndex: number}) => {
	const [selectedViewAdjudication, setSelectedViewAdjudication] = useState<any | null>(null);
	const [selectedInvitedAdjudicator, setSelectedInvitedAdjudicator] = useState<any | null>(null);

	const [showAdjudicationDetails, setShowAdjudicationDetails] = useState<boolean>(false);
	return (
		<>  {showAdjudicationDetails && selectedViewAdjudication ? (
			<AdjudicationDetailsModal
				invitedAdjudicator={selectedInvitedAdjudicator}
				adjudicationFeedback={selectedViewAdjudication}
				onClose={() => setSelectedViewAdjudication(null)}
				configs={configs}
				roundIndex={roundIndex}
			/>
		) : null}
			<Flex flexDirection="column" gap={2}>
				<Text textStyle="headingGroup">Round Adjudications</Text>
				<Table>
					<Table.HeaderRow>
						<Table.HeaderCell flex="1" textAlign="left">
							Adjudicator
						</Table.HeaderCell>
						<Table.HeaderCell flex="1" textAlign="left">
							<Flex alignItems={'center'} gap={2}>
								<Text> Status</Text>
								<Tooltip
									label={'Review statuses at the time editors finalized this round.'}
									placement='top'
								>
									<Box>
										<ButtonIcon
											size='small'
											icon={<FontAwesomeIcon icon={faInfoCircle} />}
											ariaLabel='status-info'
										/>
									</Box>
								</Tooltip>
							</Flex>
						</Table.HeaderCell>
						<Table.HeaderCell flex="1" textAlign="left">
							Recommendation
						</Table.HeaderCell>
						<Table.HeaderCell flex="1" textAlign="left">
						</Table.HeaderCell>
					</Table.HeaderRow>
					<Table.Body sx={{ borderTop: 'none' }}>
						{revision.invitedAdjudicators?.map(invitedAdjudicator => {
							const adjudicatorFeedback = revision.adjudicatorOriginalFeedback?.find(revisionFeedback => revisionFeedback.adjudicationId === invitedAdjudicator.adjudicationId) ?? null;
							return (
								<Table.Row key={adjudicatorFeedback?.adjudicationId ?? invitedAdjudicator?.adjudicationId}>
									<Table.RowCell
										flex="1"
										textStyle="headingItem"
										textAlign="left"
									>
										<Flex
											flexDirection="column"
											alignItems="flex-start"
											gap={2}
										>
											<Box>
												<Text textStyle="headingLine">
													{invitedAdjudicator.firstName} {invitedAdjudicator.lastName}
												</Text>
												<Text textStyle="textContext">
													{invitedAdjudicator.affiliation}
												</Text>
											</Box>
											{invitedAdjudicator?.role === 'boardMember' && (
                        <Badge size="context" variant="attention">
                          Board Member
                        </Badge>
                      )}
										</Flex>
									</Table.RowCell>
									<Table.RowCell flex="1" textAlign="left">
										{reviewStatusBadges[invitedAdjudicator.status]}
									</Table.RowCell>
									<Table.RowCell flex="1" textAlign="left">
										{recommendationBadges[adjudicatorFeedback?.recommendation as string] ?? 'N/A'}
									</Table.RowCell>
									<Table.RowCell flex="1" textAlign="right">
										<ButtonText
											variant="primary"
											onClick={() => {
												setSelectedViewAdjudication(adjudicatorFeedback?.reviewAssessment);
												setSelectedInvitedAdjudicator(invitedAdjudicator)
												setShowAdjudicationDetails(true);
											}}
											isDisabled={!adjudicatorFeedback}
										>
											View Adjudication
										</ButtonText>
									</Table.RowCell>
								</Table.Row>
							);
						})}
					</Table.Body>
				</Table>
			</Flex>
		</>
	)
}

export default AdjudicationRoundHistory;